//This class came with the UI template we purchased. It had a bunch of junk we didn't need, so Gilmer tried to purge it a bit.
//this is the template of the page once the user has logged in: header and main menu. The space on the right will be filled in with sub-pages.
import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { MenuItems, Menu } from '../../shared/menu-items/menu-items';
import { MessageBoxComponent } from '../../shared/message-box/message-box.component';
import { WebService, SimpleOption } from '../../shared/web-service/web.service';
import { Formatter, SessionSave } from '../../shared/utilities/utilities';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'hidden',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ]),
  ]
})
export class AdminComponent implements OnInit {
  @ViewChild('modalChangePwd') modalChangePwd;
  @ViewChild('modalChangeUserInfo') modalChangeUserInfo;
  @ViewChild('modalHelpAbout') modalHelpAbout;
  @ViewChild('msgBox', { static: true }) msgBox: MessageBoxComponent;

  public static staticInstance: AdminComponent;

  public navType: string;
  public themeLayout: string;
  public verticalPlacement: string;
  public verticalLayout: string;
  public pcodedDeviceType: string;
  public verticalNavType: string;
  public verticalEffect: string;
  public vnavigationView: string;
  public freamType: string;
  public sidebarImg: string;
  public sidebarImgType: string;
  public layoutType: string;

  public headerTheme: string;
  public pcodedHeaderPosition: string;

  public liveNotification: string;
  public liveNotificationClass: string;

  public profileNotification: string;
  public profileNotificationClass: string;

  public navRight: string;
  public windowWidth: number;

  public toggleOn: boolean;
  public navBarTheme: string;
  public activeItemTheme: string;
  public pcodedSidebarPosition: string;

  public menuTitleTheme: string;
  public dropDownIcon: string;
  public subItemIcon: string;

  public headerFixedMargin: string;
  public sidebarFixedHeight: string;
  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public itemBorder: boolean;
  public employeeName: string;
  public visiblePage;

  public config: any;

  newEmail: string;
  infoErrorMsg: string;
  showInfoErrorMsg: boolean = false;
  passwordOld: string;
  passwordNew: string;
  passwordConfirm: string;
  passwordErrorMsg: string;
  showPasswordErrorMsg: boolean = false;
  nonprofitName: string = sessionStorage.nonprofitName;
  tokenExpirationSeconds: number;
  revealPwd1: boolean = false;
  revealPwd2: boolean = false;
  revealPwd3: boolean = false;
  rowDataNavigationPage: object[] = [];
  lastPageClickeOn: string;
  parentMenuName: string;
  artificiallyHighlightedMenuItem: boolean;

  nonprofitList: SimpleOption[] = []; //data source for the nonprofit dropdown options
  selectedNonprofitId: string = sessionStorage.selectedNonprofitId;
  browserRegistered: boolean = (sessionStorage.browserRegistered == "1");
  mainMenuItems: Menu[];

  constructor(public menuItems: MenuItems, private webService: WebService) {
    AdminComponent.staticInstance = this;

    // This will go through all the items in the main menu on the left side of the screen and remove any items that the current user doesn't have permission to view. The MainMenuItems array is the top nodes. Each node has a rolesCanView property. Then those might have children of type ChildrenItems that also have a rolesCanView property. The rolesCanView property is a comma-delim list of roles that can access the page. We get an array of roles that the current user has from sessionStoriage. We go through each MainMenuItems node and each ChildrenItems node, and remove any item from the array where the roles of the current user aren't found in the list of roles for the page. For the arrays, we start at the end and go backwards, so things don't get messed up if we remove an item from the array.
    let userRoles: string[] = JSON.parse(sessionStorage.authorityRoles);
    let tempMenuItems: Menu[] = menuItems.getAll();
    for (let i = tempMenuItems[0].main.length - 1; i >= 0; i--) {
      // check all the top-level nodes
      if (!this.foundRoleMatch(userRoles, tempMenuItems[0].main[i].rolesCanView)) {
        tempMenuItems[0].main.splice(i, 1);
      }
      else if (tempMenuItems[0].main[i].children) {
        for (let x = tempMenuItems[0].main[i].children.length - 1; x >= 0; x--) {
          // check all the children nodes
          if (!this.foundRoleMatch(userRoles, tempMenuItems[0].main[i].children[x].rolesCanView)) {
            tempMenuItems[0].main[i].children.splice(x, 1);
          }
        }
      }
    }
    // There is HTML that is bound to mainMenuItems to create the menu
    this.mainMenuItems = tempMenuItems;

    if (sessionStorage.tokenExpirationSeconds) {
      this.tokenExpirationSeconds = parseInt(sessionStorage.tokenExpirationSeconds);
      setInterval(() => {
        if (sessionStorage.lastWebApiCall) {
          let numSecondsSinceLastApiCall = (new Date().getTime() - parseInt(sessionStorage.lastWebApiCall)) / 1000;
          if (numSecondsSinceLastApiCall > this.tokenExpirationSeconds) {
            console.log("Auto log out user because it's been too long (past token expiration) since they've done anything that has used an API call.");
            sessionStorage.clear();
            sessionStorage.logoutReason = "AuthorizationError";
            window.location.assign(document.getElementsByTagName('base')[0].href + "login");
          }
        }
      }, 60000);
    }

    let nonprofitListStr: string = sessionStorage.nonprofitList;
    if (nonprofitListStr && nonprofitListStr != 'null' && nonprofitListStr != 'undefined') {
      this.nonprofitList = JSON.parse(nonprofitListStr);
    }

    this.employeeName = sessionStorage.employeeName;
    if (!this.employeeName || this.employeeName.length === 0 || !sessionStorage.validationToken || sessionStorage.validationToken.length === 0)
      this.onLogout();

    this.navType = 'st2';
    this.themeLayout = 'vertical';
    this.verticalPlacement = 'left';
    this.verticalLayout = 'wide';
    this.pcodedDeviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.vnavigationView = 'view1';
    this.freamType = 'theme1';
    this.sidebarImg = 'false';
    this.sidebarImgType = 'img1';
    this.layoutType = 'light';

    this.pcodedHeaderPosition = 'fixed';

    this.liveNotification = 'an-off';
    this.profileNotification = 'an-off';

    this.navRight = 'nav-on';

    this.windowWidth = window.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    this.toggleOn = true;
    this.navBarTheme = 'theme1';
    //this.activeItemTheme = 'theme10'; 
    this.pcodedSidebarPosition = 'fixed';
    this.menuTitleTheme = 'theme6';
    //this.dropDownIcon = 'style3';
    this.subItemIcon = 'style7';

    this.headerFixedMargin = '56px';
    this.sidebarFixedHeight = 'calc(100vh - 56px)';
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.itemBorder = true;

    this.setMenuAttributes(this.windowWidth);
    this.setHeaderAttributes(this.windowWidth);

    // dark
    /*this.setLayoutType('dark');*/

    // light-dark
    /*this.setLayoutType('dark');
    this.setNavBarTheme('themelight1');*/

    // dark-light
    /*this.setNavBarTheme('theme1');*/

    // side-bar image
    /*this.setLayoutType('img');*/
    //???These are ones customized by Gilmer. See setLayoutType()
    this.layoutType = 'light';
    this.sidebarImg = 'false';
    this.navBarTheme = 'theme1';
    this.menuTitleTheme = 'theme1';
    document.querySelector('body').classList.remove('dark');
    this.headerTheme = 'theme1';
    this.dropDownIcon = 'style1';
    this.activeItemTheme = 'theme1'//this is for the color of the selected menu item.
  }

  //returns true if any of the roles in userRoles (comma-delim list of all the roles for the user) is found in rolesForPage (comma-delim list of the roles that can access a page)
  foundRoleMatch(userRoles: string[], rolesForPage: string): boolean {
    let rval: boolean = false;
    userRoles.forEach(elem => {
      if (rolesForPage.indexOf(elem) != -1)
        rval = true;
    });
    return rval;
  }

  ngOnInit() {
    this.setBackgroundPattern('pattern1');
    // The msgBox of this component can be used anywhere. Use setTimeout to make sure the object has been created.
    setTimeout(() => {
      MessageBoxComponent.staticInstance = this.msgBox;
    }, 100);
    /*document.querySelector('body').classList.remove('dark');*/

    this.GetReceivingAccountsList();
  }

  GetReceivingAccountsList() {
    //The list of receiving accounts is used by a number of pages throughout the system, but not by this page.
    this.webService.options_GetAllReceivingAccounts().subscribe(
      apiResponse => {
        if (apiResponse.errorCode === 0) {
          SessionSave.save(SessionSave.receivingAccountsKey, apiResponse.accountList);
        }
      }
    );
  }

  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.setHeaderAttributes(this.windowWidth);

    let reSizeFlag = true;
    if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.pcodedDeviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setHeaderAttributes(windowWidth) {
    if (windowWidth < 992) {
      this.navRight = 'nav-off';
    } else {
      this.navRight = 'nav-on';
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.pcodedDeviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else if (windowWidth < 768) {
      this.pcodedDeviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleHeaderNavRight() {
    this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
  }

  toggleLiveNotification() {
    this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'active' : '';
  }

  toggleProfileNotification() {
    this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'active' : '';
  }

  notificationOutsideClick(ele: string) {
    if (ele === 'live' && this.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    }
  }

  toggleOpened() {
    if (this.windowWidth < 992) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      if (this.navRight === 'nav-on') {
        this.toggleHeaderNavRight();
      }
    }
    this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
  }

  onClickedOutsideSidebar(e: Event) {
    if ((this.windowWidth < 992 && this.toggleOn && this.verticalNavType !== 'offcanvas') || this.verticalEffect === 'overlay') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  setNavBarTheme(theme: string) {
    if (theme === 'themelight1') {
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      this.sidebarImg = 'false';
    } else {
      this.menuTitleTheme = 'theme6';
      this.navBarTheme = 'theme1';
      this.sidebarImg = 'false';
    }
  }

  setLayoutType(type: string) {
    this.layoutType = type;
    if (type === 'dark') {
      this.headerTheme = 'theme1';
      this.sidebarImg = 'false';
      this.navBarTheme = 'theme1';
      this.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.add('dark');
    } else if (type === 'light') {
      this.sidebarImg = 'false';
      this.headerTheme = 'themelight5';
      this.navBarTheme = 'themelight1';
      this.menuTitleTheme = 'theme1';
      document.querySelector('body').classList.remove('dark');
    } else if (type === 'img') {
      this.sidebarImg = 'true';
      this.headerTheme = 'theme1';
      this.navBarTheme = 'theme1';
      this.menuTitleTheme = 'theme6';
      document.querySelector('body').classList.remove('dark');
    }
  }

  setBackgroundPattern(pattern: string) {
    document.querySelector('body').setAttribute('themebg-pattern', pattern);
  }

  onShowAbout() {
    this.modalHelpAbout.show();
    setTimeout(function () { $("#aboutModalOkButton").focus() }, 300); //set focus on button so if user clicks Enter, it will close. We have to use setTimeout to set the focus because you can't set focus until it appears, which takes a moment.
  }

  onChangeUserInfo() {
    this.passwordOld = "";
    this.passwordNew = "";
    this.passwordConfirm = "";
    this.showPasswordErrorMsg = false;
    this.modalChangeUserInfo.show();
    setTimeout(function () { $("#passwordOld").focus() }, 300); //set focus on first field
  }

  finishChangeUserInfo() {
    if (this.newEmail.length === 0) {
      this.infoErrorMsg = "Email address cannot be blank.";
      this.showInfoErrorMsg = true;
      return;
    }
    if (!Formatter.validateEmail(this.newEmail)) {
      this.infoErrorMsg = "Email address is invalid format.";
      this.showInfoErrorMsg = true;
      return;
    }

    this.showInfoErrorMsg = false;

    this.webService.authentication_EditUserSimple(this.newEmail).subscribe(
      apiResponse => {
        if (apiResponse.errorCode === 0) {
          //change pwd worked
          this.modalChangeUserInfo.hide();
          this.msgBox.show("Success", "Your info has been changed.", false);
        }
        else {
          //server says something didn't work, so show message from server.
          this.infoErrorMsg = apiResponse.errorMessage;
          this.showInfoErrorMsg = true;
        }
      }
    );
  }

  onChangePwd() {
    this.passwordOld = "";
    this.passwordNew = "";
    this.passwordConfirm = "";
    this.showPasswordErrorMsg = false;
    this.modalChangePwd.show();
    setTimeout(function () { $("#passwordOld").focus() }, 300); //set focus on first field
  }

  finishChangePwd() {
    if (this.passwordOld.length === 0 || this.passwordNew.length === 0 || this.passwordConfirm.length === 0) {
      this.passwordErrorMsg = "Please enter your old password, new password, and confirmation password.";
      this.showPasswordErrorMsg = true;
      return;
    }
    if (this.passwordNew !== this.passwordConfirm) {
      this.passwordErrorMsg = "The new password does not match the confirmation password.";
      this.showPasswordErrorMsg = true;
      return;
    }

    this.showPasswordErrorMsg = false;

    this.webService.authentication_ChangePassword(sessionStorage.userName, this.passwordOld, this.passwordNew, '').subscribe(
      apiResponse => {
        if (apiResponse.errorCode === 0) {
          //change pwd worked
          this.modalChangePwd.hide();
          this.msgBox.show("Success", "Your password has been changed.", false);
          this.revealPwd1 = false;
          this.revealPwd2 = false;
          this.revealPwd3 = false;
        }
        else {
          //server says something didn't work, so show message from server.
          this.passwordErrorMsg = apiResponse.errorMessage;
          this.showPasswordErrorMsg = true;
        }
      }
    );
  }

  onLogout() {
    this.webService.authentication_LogUserLogout();
    sessionStorage.clear();
    //we redirect the browser URL to the login page. We do it after a 10 ms pause to allow the AP call above to get going.
    //we can't just do window.location.pathname = "login" because it's possible our URL has a virtual folder we need to worry about.
    setTimeout(() => window.location.assign(document.getElementsByTagName('base')[0].href + "login"), 10);
  }

  // If the user selects a different nonprofit from the dropdown, we make a call to the server that will switch the UI into doing everything for that nonprofit.
  // This is done by making a call to the server that will put the new nonprofitNo into the validation token.
  onNonprofitSelected(event) {
    // The value of the selected option in the nonprofit dropdown will be have two things separated by an underscore:
    // the first is the nonprofitNo and the second is either "0" or "1" depending on whether the nonprofit is active.
    let arr: Array<string> = this.selectedNonprofitId.split("_");
    if (arr.length !== 2) { //this should never happen.
      this.msgBox.show("Error", "Please contact technical support.", false);
      return;
    }
    this.webService.authentication_ChangeNonprofitNo(Number(arr[0])).subscribe(
      apiResponse => {
        if (this.visiblePage && this.visiblePage.refreshData)
          this.visiblePage.refreshData();
        this.GetReceivingAccountsList();
        sessionStorage.selectedNonprofitId = this.selectedNonprofitId;
        // We don't have to check the errorCode of the apiResponse because it will never be an error.
        if (arr[1] === "0") {
          this.msgBox.show("Warning", "The selected non-profit is inactive.", false);
        }
      }
    );
  }

  onForgetMe() {
    this.msgBox.show("Confirm", `Are you sure you want to remove your registration on this browser? If you do this, you will need to go through two-step authentication the next time you log in.`, true,
      () => {
        this.webService.authentication_DeleteUserAuth(localStorage.browserGuid).subscribe();
      });
  }

  //This is the event when you click on one of the main menu items that has children. The menu item expands to show the children (sub-pages). Brad was concerned that users could be confused because they are expecting something to happen in the main page area beyond just the menu expanding, so he wanted to have a "landing page" (as he called it) appear that has links to the sub-pages. This is implemented as a panel that is normally hidden. 
  onMainMenuParentItemClicked(menuItem, clickEvent) {
    //The currently selected page has styling in the nav menu: a different color and or boldness in the text item that is caused by the "li" grandparent of the clicked element having the "active" class on it. This will remove the "active" class from all the "li" elements in the nav menu and then add the class to the item that was just clicked. The artificiallyHighlightedMenuItem var will be true if this one being selected is different than the one already selected and false if the user clicked on the one already selected.
    this.artificiallyHighlightedMenuItem = !$(clickEvent.target.parentElement.parentElement).hasClass("active");
    $('#main_navbar').find('li').removeClass("active");
    $(clickEvent.target.parentElement.parentElement).addClass("active");

    this.parentMenuName = menuItem.name.toLowerCase();
    //This will put some entries in the rowDataNavigationPage array, which is the data source for the panel, which will create the links. Each object in the array has two properties: caption and url. menuItem (param passed into this function) represents the main menu item clicked by the user. It has children, which are the sub-items. See the data structure in menu-items.ts to understand the structure of menuItem. The URL will need to have the "state" of the main menu item and "state" of the children menu item together.
    this.rowDataNavigationPage.length = 0;
    for (let i = 0; i < menuItem.children.length; i++) {
      this.rowDataNavigationPage.push({
        caption: menuItem.children[i].name,
        url: `/${menuItem.state}/${menuItem.children[i].state}`,
        tooltip: menuItem.children[i].tooltip
      });
    }
    //The first child of the pageWrapper div is the hidden panel (landing page) that has the links. The third child is the page that is normally there (e.g. it could be the Donors page or Users page or whatever...it gets swapped out by the Angular framework). So we make the landing page panel visible and the normal page invisible.
    let node = document.getElementById("pageWrapper");
    if (node.children.length > 0)
      (<HTMLElement>node.children[0]).style.display = "";
    if (node.children.length > 2)
      (<HTMLElement>node.children[2]).style.display = "none";
    //We also make the page title change to the clicked node because we are no longer showing the old page.
    const t = document.getElementById("titleString");
    if (t)
      t.innerText = menuItem.name;
  }

  //This is the event when you click on a page to view something in the system. It reverses the hiding/showing that was done in onMainMenuParentItemClicked(). When a link is clicked to show a page, we want to hide the landing page panel and show the normal page.
  onMainMenuChildItemClicked(pageName: string, clickEvent) {
    //The currently selected page has styling in the nav menu: a different color and or boldness in the text item that is caused by the "li" grandparent of the clicked element having the "active" class on it. This will remove the "active" class from all the "li" elements in the nav menu and then add the class to the item that was just clicked. We have to do this because of some weird bugs that appear with the way we are adding/removing the class in onMainMenuParentItemClicked. 
    if (this.artificiallyHighlightedMenuItem) {
      $('#main_navbar').find('li').removeClass("active");
      this.artificiallyHighlightedMenuItem = false;
    }
    if (clickEvent)
      $(clickEvent.target.parentElement.parentElement).addClass("active");
    //We also make the page title change to the clicked node
    const t = document.getElementById("titleString");
    if (t)
      t.innerText = pageName;

    let node = document.getElementById("pageWrapper");
    if (node.children.length > 0)
      (<HTMLElement>node.children[0]).style.display = "none";
    if (pageName == this.lastPageClickeOn && node.children.length > 2)
      (<HTMLElement>node.children[2]).style.display = "";
    //We save this because if you are clicking on a new page, we don't want to display node.children[2] because it will make the old page appear for a second before it's replaced by the new page. If they are clicking on the page that they are already on, we want to display it immediately.
    this.lastPageClickeOn = pageName;
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }
}
